import { useQuery } from "@tanstack/react-query";

import { useApiClient } from "../../../../api-client";
import OnboardingKeys from "../queryKeys";
import { OnboardingRequest, OnboardingTypes } from "./useOnboarding.types";

const restoreOnboarding = (
  onboarding: OnboardingRequest
): OnboardingRequest | undefined => {
  if (!onboarding) return { name: OnboardingTypes.NO_ONBOARDING };

  return { name: onboarding.name };
};

const useOnboarding = () => {
  const { get } = useApiClient();

  const find = async () => {
    const res = await get("/v1/employees/onboarding");
    return restoreOnboarding(res.data);
  };

  return useQuery({
    queryKey: [OnboardingKeys.ONBOARDING],
    queryFn: find,
  });
};

export default useOnboarding;
